import { optionsCreator } from './utils';

export const ACTIONS_NAMESPACE = 'reinter';
export const SUCCEEDED = 'SUCCEEDED';
export const FAILED = 'FAILED';

export const AJAX_DEBOUNCE_TIME = 300;
export const AJAX_TIMEOUT = 60000;
export const AJAX_RETRY_LIMIT = 3;
export const AJAX_RETRY_DELAY = 200;

export const ALERTS_TIMEOUT = 3000;

export const SLIDER_NUMBERS_CLICK_DEBOUNCE_TIME = 250;

export const FILTER_DEBOUNCE_TIMEOUT = 800;

export const INVALID_TOKEN_CODE = 607;
export const SUCCESS_CODE = 200;

export const DATE_FORMAT_INPUT = 'DD/MM/YYYY';
export const DATE_FORMAT = 'YYYY-MM-DD';

export const sliderButtonNumbersTitles = [
  'Rayado',
  'Abollado',
  'Flojo',
  'Óxido',
  'Picadura',
  'Cortado',
  'Faltante',
  'Doblado',
  'Dañado',
  'Por chequear'
];

export const storageKeys = {
  token: 'rnt:tkn',
  techniciansForm: 'tech:form'
};

export const otherOption = {
  id: 'other',
  name: 'Otro'
};

export const userRoles = {
  admin: {
    label: 'Admin',
    value: 2
  },
  client: {
    label: 'Cliente',
    value: 4
  },
  superAdmin: {
    label: 'Superadmin',
    value: 1
  },
  technician: {
    label: 'Técnico',
    value: 3
  }
};

export const dialogTitles = {
  booking: 'Booking',
  create: 'Crear',
  delete: 'Eliminar',
  edit: 'Editar',
  estimate: 'Estimar',
};

export const stateTypes = {
  active: {
    identifier: 'A',
    label: 'Activo',
    value: 1,
  },
  inactive: {
    identifier: 'I',
    label: 'Inactivo',
    value: 2
  }
};

export const yesOrNo = (isBoolean = false, { labels: { no: noLabel = 'No', yes: yesLabel = 'Sí' } = {} } = {}) => ({
  yes: {
    label: yesLabel,
    value: isBoolean ? 'true' : 'S'
  },
  no: {
    label: noLabel,
    value: isBoolean ? 'false' : 'N'
  }
});

export const goodOrBad = {
  bad: {
    label: 'Malo',
    value: 'MALO'
  },
  good: {
    label: 'Bueno',
    value: 'BUENO'
  }
};

export const dateTypes = {
  creation: {
    key: 'createdDate',
    label: 'Creación',
    value: 1
  },
  expiration: {
    key: 'dueDate',
    label: 'Expiración',
    value: 2
  }
};

export const emptyFullTypes = {
  empty: {
    label: 'Sí',
    value: 4
  },
  full: {
    label: 'No',
    value: 5
  }
};

export const gateTypes = {
  in: {
    label: 'In',
    value: 34
  },
  out: {
    label: 'Out',
    value: 36
  }
};

export const tableModes = {
  booking: 'booking',
  create: 'create',
  delete: 'delete',
  edit: 'edit',
  estimate: 'estimate',
  excel: 'excel',
  pdf: 'pdf',
  template: 'template'
};

export const appRoutes = {
  login: 'login',
  dashboard: {
    advancedSearch: 'busqueda-avanzada',
    carriers: 'transportistas',
    clients: 'clientes',
    containersDamage: 'danos-de-contenedores',
    depots: 'predios',
    editableFields: 'campos-editables',
    index: 'dashboard',
    notifications: 'notificaciones',
    operations: 'bitacora-de-operaciones',
    pilots: 'pilotos',
    templates: 'plantillas',
    users: 'usuarios',
    massUpload: 'carga-de-inventario',
    advancedSearchClient: 'busqueda-avanzada-cliente'
  },
  clients: {
    index: 'clientes'
  },
  technicians: {
    index: 'tecnicos'
  }
};

export const excelMimeTypes = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'application/vnd.ms-excel.addin.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
];

export const dateTypesOptions = optionsCreator(dateTypes);

export const emptyFullOptions = optionsCreator(emptyFullTypes);

export const gateTypesOptions = optionsCreator(gateTypes);

export const goodOrBadOptions = optionsCreator(goodOrBad);

export const userRolesOptions = optionsCreator(userRoles);

export const yesOrNoOptions = (isBoolean = false, options) => optionsCreator(yesOrNo(isBoolean, options));



// WEBPACK FOOTER //
// ./src/shared/constants.js